<template>
	<v-container fluid class="pa-0">
		<payment-list
			v-model="payments"
			:loading="isLoading"></payment-list>
	</v-container>
</template>
<script>
import backendService from "@/services/backend-service";
import PaymentList from "@/components/PaymentList.vue";

export default {
	name: "PaymentListView",
	components: {
		"payment-list": PaymentList,
	},
	mounted: function () {
		this.getPayments();
	},
	data() {
		return {
			isLoading: false,
			payments: [],
		};
	},
	methods: {
		getPayments() {
			this.isLoading = true;
			backendService
				.getPayments()
				.then((response) => {
					this.payments = response.data;
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
	},
};
</script>
